



































import Vue, { PropType } from 'vue';
import EntityPageDetailsList from '@/components/EntityPageDetailsList.vue';
import Label from '@/components/Label.vue';
import LocationPinIcon from '@/components/icons/LocationPinIcon';
import HomeMallIcon from '@/components/icons/HomeMallIcon';
import BusinessUnitIcon from '@/components/icons/BusinessUnitIcon';
import PhoneIcon from '@/components/icons/PhoneIcon';

interface IMall {
  id: string;
  name: string;
}

export default Vue.extend({
  name: 'BaseBusinessOverviewDetails',
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    description: String,
    address: {
      type: String,
    },
    level: String,
    unit: String,
    phone: String,
    rating: Number,
    pricing: Number,
    mall: Object as PropType<IMall>,
  },
  components: {
    EntityPageDetailsList,
    Label,
    LocationPinIcon,
    HomeMallIcon,
    BusinessUnitIcon,
    PhoneIcon,
  },
});
